module.exports = __webpack_public_path__ + "static/img/icon-report.85c4e1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/icon-report.png
// module id = o1LH
// module chunks = 15